import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Message } from 'jl-design-system/components/message/Message';

import { getErrorMessage, getSuccessMessage, getInfoMessage } from '../messages.constants';
import { MessageDescription } from '../message-info';

import styles from '~/components/layout/SidebarLayout.scss';
export class MessageNotification extends PureComponent {
  render() {
    const { message, children } = this.props;
    const { type } = message;
    const { notificationType, title, description } = {
      ...getErrorMessage(type),
      ...getSuccessMessage(type),
      ...getInfoMessage(type),
      ...message,
    };

    const bodyArray = [
      description && <MessageDescription message={description} key="1" />,
      children && <div key="2">{children}</div>,
    ].filter(Boolean);

    return (
      <Message
        title={title}
        type={notificationType}
        animation="shake"
        body={bodyArray.length ? <div>{bodyArray}</div> : undefined}
        className={styles.message}
      />
    );
  }
}

MessageNotification.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  children: PropTypes.node,
  classnameModifier: PropTypes.string,
};

MessageNotification.defaultProps = {
  children: null,
  classnameModifier: '',
};
